import {
  axiosGetPaginatedRequest,
  axiosGetRequest,
  axiosPatchRequest,
  getCommunityRoute,
  getIdentityRoute,
} from '../api';
import { MemberInfo } from '../profile';

const PAGE_SIZE = 20;
const getRoomDetailsRoute = () => `${getCommunityRoute()}/room`;

const addRoomIdToCall = (roomId?: string) => {
  return roomId ? `/${roomId}` : '';
};

export const sendCompanionRequestCall = (
  companionId: string,
  roomId?: string
) => {
  return axiosPatchRequest<void, MemberInfo[]>(
    `${getIdentityRoute()}/companion/${companionId}/send/room${addRoomIdToCall(
      roomId
    )}`
  );
};

export const rejectCompanionRequestCall = (
  companionId: string,
  roomId?: string
) => {
  return axiosPatchRequest<void, Notification>(
    `${getIdentityRoute()}/companion/${companionId}/reject/room${addRoomIdToCall(
      roomId
    )}`
  );
};

export const acceptCompanionRequestCall = (
  companionId: string,
  roomId?: string
) => {
  return axiosPatchRequest<void, Notification>(
    `${getIdentityRoute()}/companion/${companionId}/accept/room${addRoomIdToCall(
      roomId
    )}`
  );
};

export const fetchCompanionsCall = (
  xMsContinuationToken?: string,
  numrecs?: number,
  doNotRenewToken?: boolean
) => {
  return axiosGetPaginatedRequest<MemberInfo[]>(
    `${getIdentityRoute()}/companions/${numrecs || -1}`,
    xMsContinuationToken,
    doNotRenewToken
  );
};

export const removeCompanionCall = (companionId: string, roomId?: string) => {
  return axiosPatchRequest<string, void>(
    `${getIdentityRoute()}/companion/${companionId}/remove/room${addRoomIdToCall(
      roomId
    )}`
  );
};

export const fetchCompanionsInTheRoomCall = (
  roomId: string,
  xMsContinuationToken?: string,
  numrecs?: number
) => {
  return axiosGetPaginatedRequest<MemberInfo[]>(
    `${getRoomDetailsRoute()}/${roomId}/companions/${numrecs || PAGE_SIZE}`,
    xMsContinuationToken
  );
};

export const fetchCompanionsInTheRoomCountCall = (roomId: string) => {
  return axiosGetRequest<number>(
    `${getRoomDetailsRoute()}/${roomId}/companioncount`
  );
};
